import { render, staticRenderFns } from "./personnel-change-result.view.vue?vue&type=template&id=33d5e500&"
import script from "./personnel-change-result.view.vue?vue&type=script&lang=ts&"
export * from "./personnel-change-result.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports